<input type="hidden" name="menuType" id="menuType" value="public" />
<div tabindex="101" *ngIf="appError" class="ontario-row" aria-live="polite" aria-atomic="true" id="pageLevelMessageId"
  id="pageLevelMessageId" #pageMsg>
  <div class="ontario-columns">
    <div class="ontario-alert ontario-alert--error">
      <div class="ontario-alert__header">
        <div class="ontario-alert__header-icon">
          <svg class="ontario-icon" alt="Error" aria-hidden="true" focusable="false" sol:category="primary"
            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
            <use href="#ontario-icon-alert-error"></use>
          </svg>
        </div>
        <h2 class="ontario-alert__header-title ontario-h4">
          {{ "bss.error" | translate }}
        </h2>
      </div>
      <div class="ontario-alert__body">
        <p [innerHTML]="appErrorMessage | translate">
      </div>
    </div>
  </div>
</div>

<div *ngIf="appSuccess && !appError" class="ontario-row" aria-live="polite" aria-atomic="true" id="pageLevelMessageId"
  #pageMsg>
  <div class="ontario-columns ontario-small-12">

    <div class="ontario-alert ontario-alert--success">
      <div class="ontario-alert__header">
        <div class="ontario-alert__header-icon">
          <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
            <use href="#ontario-icon-alert-success"></use>
          </svg>
        </div>
        <h2 class="ontario-alert__header-title ontario-h4">{{'bss.success' | translate}}:</h2>
      </div>
      <div class="ontario-alert__body">
        <p [innerHTML]="appSuccessMessage | translate"></p>
      </div>
    </div>
  </div>
</div>

<form [formGroup]="passwordResetForm" (ngSubmit)="onSubmit()">
  <div class="ontario-row">
    <div class="ontario-columns">
      <h2 id="pageTitle">{{ "bss.SetNewPassword.title" | translate }}</h2>
      <hr>
      <p>{{"bss.SetNewPassword.content"| translate}}</p>

    </div>
  </div>

  <div class="ontario-row">
    <dl><dt></dt><dd>
      <div class="ontario-columns ontario-small-12 ontario-medium-3">
        <label class="ontario-label" for="email">
          {{ 'bss.setNewPassword.email' | translate }}<span class="ontario-label__flag"> ({{'bss.required' |
            translate }})</span>
        </label>
      </div>
      <div class="ontario-columns ontario-small-12 ontario-medium-9">
        <input class="ontario-input ontario-input--20-char-width" type="text" id="email" tabindex="102"
          title="{{ 'bss.setNewPassword.email.instruction' | translate }}" formControlName="email" appLowercase />

        <div id="emailError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error " *ngIf=" (submitted || passwordResetForm.get('email').touched || passwordResetForm.get('email').dirty) 
                && (passwordResetForm.get('email').errors?.['required'])">
          {{ 'bss.setNewPassowrd.email.err.email.required' | translate }}
        </div>

        <div id="emailError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error "
          *ngIf="(submitted || passwordResetForm.get('email').touched || passwordResetForm.get('email').dirty) && ( passwordResetForm.get('email')?.hasError('email') || passwordResetForm.get('email')?.hasError('invalidEmail') )">
          {{'bss.user.email.err.newEmail.invalid' | translate}}
        </div>

        <div id="emailError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error " *ngIf="(submitted || passwordResetForm.get('email').touched || passwordResetForm.get('email').dirty) 
                && (passwordResetForm.get('email').errors?.['restricted'])">
          {{'bss.login.err.email.restricted' | translate}}
        </div>

        <div id="emailError" role="alert" aria-live="assertive" *ngIf="(submitted || passwordResetForm.get('email').touched || passwordResetForm.get('email').dirty) 
                && passwordResetForm.hasError('containsCurrentEmail')" class="ontario-alert ontario-alert--error">
          {{'bss.user.email.err.email.contains.curent' | translate }}
        </div>

      </div>
    </dd></dl>
  </div>
  <div class="ontario-row">
    <dl><dt></dt><dd>
      <div class="ontario-columns ontario-small-12 ontario-medium-3">

        <label class="ontario-label" for="tempPassword">
          {{ "bss.setNewPassowrd.temporary" | translate
          }}<span class="ontario-label__flag">
            ({{ "bss.passwordReset.required" | translate }})</span>
        </label>
      </div>
      <div class="ontario-columns ontario-small-12 ontario-medium-9">
        <div class="toggle-container ontario-input--20-char-width">
          <input tabindex="103" class="ontario-input ontario-input--20-char-width"
            type="{{ showPasswordTemp === false ? 'password' : 'text' }}" id="tempPassword"
            title="{{ 'bss.setNewPassword.temporary.required' | translate }}" formControlName="tempPassword"
            aria-describedby="tempPasswordError" />
          <a tabindex="104" *ngIf="passwordResetForm.get('tempPassword').value" id="passwordTempToggler"
            (click)="togglePasswordTemp()"
            title="{{ showPasswordTemp === false ? ('bss.passwordReset.showNewPassword.title' | translate) : ('bss.passwordReset.hideNewPassword.title' | translate) }}">
            {{ showPasswordTemp === false ? ('bss.passwordReset.newPassword.show' | translate) :
            ('bss.passwordReset.newPassword.hide' | translate) }}
          </a>
        </div>

        <!-- <div class="ontario-alert ontario-alert--error ontario-hide">
          {{ "bss.passwordReset.error.newPassword.required" | translate }}
        </div> -->

        <div
          *ngIf="(passwordResetForm.get('tempPassword').touched || passwordResetForm.get('tempPassword').dirty || submitted) && (passwordResetForm.get('tempPassword').errors?.['required'])"
          role="alert" aria-live="assertive" id="tempPasswordError" class="ontario-alert ontario-alert--error">
          <ul>
            <li>
              {{ "bss.setNewPassword.temporary.password.required" | translate }}
            </li>
          </ul>
        </div>

        <div *ngIf="(passwordResetForm.get('tempPassword').touched || passwordResetForm.get('tempPassword').dirty || submitted) && 
      !(passwordResetForm.get('tempPassword').errors?.['required']) && passwordResetForm.get('tempPassword').invalid"
          role="alert" aria-live="assertive" id="tempPasswordError" class="ontario-alert ontario-alert--error">

          <ul>
            <div *ngIf="
              passwordResetForm.get('tempPassword').invalid &&
              passwordResetForm.get('tempPassword').hasError('startC')
            ">
              <li>
                {{
                "bss.passwordReset.error.password.beginCharacter" | translate
                }}
              </li>
            </div>

            <div *ngIf="
              passwordResetForm.get('tempPassword').invalid &&
              passwordResetForm.get('tempPassword').hasError('strongL')
            ">
              <li>
                {{
                "bss.passwordReset.error.password.needLowerCase" | translate
                }}
              </li>
            </div>

            <div *ngIf="
              passwordResetForm.get('tempPassword').invalid &&
              passwordResetForm.get('tempPassword').hasError('strongU')
            ">
              <li>
                {{
                "bss.passwordReset.error.password.needUpperCase" | translate
                }}
              </li>
            </div>

            <div *ngIf="
              passwordResetForm.get('tempPassword').invalid &&
              passwordResetForm.get('tempPassword').hasError('strongD')
            ">
              <li>
                {{ "bss.passwordReset.error.password.needDigit" | translate }}
              </li>
            </div>

            <div *ngIf="
              passwordResetForm.get('tempPassword').invalid &&
              passwordResetForm.get('tempPassword').hasError('strongS')
            ">
              <li>
                {{
                "bss.passwordReset.error.password.needSpecialChar" | translate
                }}
              </li>
            </div>

            <div *ngIf="
              passwordResetForm.get('tempPassword').invalid &&
              passwordResetForm.get('tempPassword').hasError('strongDS')">
              <li>
                {{
                "bss.register.error.password.disAllowedSpecialChar" | translate
                }}
              </li>
            </div>

            <div *ngIf="
              passwordResetForm.get('tempPassword').invalid &&
              passwordResetForm.get('tempPassword').hasError('strongR')
            ">
              <li>
                {{
                "bss.passwordReset.error.password.repeatedChar" | translate
                }}
              </li>
            </div>

            <div *ngIf="passwordResetForm.get('tempPassword').invalid && 
              (passwordResetForm.get('tempPassword').errors?.['minlength'] 
              || passwordResetForm.get('tempPassword').errors?.['maxlength'] 
              || passwordResetForm.get('tempPassword').hasError('passwordTooShort'))">
              <li>
                {{ "bss.passwordReset.error.password.length" | translate }}
              </li>
            </div>

            <div *ngIf="passwordResetForm.hasError('passwordContainsEmail')">
              <li>
                {{
                "bss.passwordReset.error.password.containEmail" | translate
                }}
              </li>
            </div>

          </ul>
        </div>
      </div>
    </dd></dl>
  </div>

  <div class="ontario-row">
    <dl><dt></dt><dd>
      <div class="ontario-columns ontario-small-12 ontario-medium-3">
        <label class="ontario-label" for="newPassword">
          {{ "bss.passwordReset.newPassword" | translate
          }}<span class="ontario-label__flag">
            ({{ "bss.passwordReset.required" | translate }})</span>
        </label>
      </div>

      <div class="ontario-columns ontario-small-12 ontario-medium-9">
        <div class="toggle-container ontario-input--20-char-width">
          <input tabindex="105" class="ontario-input ontario-input--20-char-width"
            type="{{ showPasswordNew === false ? 'password' : 'text' }}" id="newPassword"
            title="{{ 'bss.passwordReset.newPassword.title' | translate }}" formControlName="newPassword"
            aria-describedby="newPasswordError" />
          <a tabindex="106" *ngIf="passwordResetForm.get('newPassword').value" id="passwordNewToggler"
            (click)="togglePasswordNew()"
            title="{{ showPasswordNew === false ? ('bss.passwordReset.showNewPassword.title' | translate) : ('bss.passwordReset.hideNewPassword.title' | translate) }}">
            {{ showPasswordNew === false ? ('bss.passwordReset.newPassword.show' | translate) :
            ('bss.passwordReset.newPassword.hide' | translate) }}
          </a>
        </div>

        <div class="ontario-alert ontario-alert--error ontario-hide">
          {{ "bss.passwordReset.error.newPassword.required" | translate }}
        </div>

        <div
          *ngIf="(passwordResetForm.get('newPassword').touched || passwordResetForm.get('newPassword').dirty || submitted) && (passwordResetForm.get('newPassword').errors?.['required'])"
          role="alert" aria-live="assertive" id="newPasswordError" class="ontario-alert ontario-alert--error">
          <ul>
            <li>
              {{ "bss.passwordReset.error.newPassword.required" | translate }}
            </li>
          </ul>
        </div>

        <div *ngIf="(passwordResetForm.get('newPassword').touched || passwordResetForm.get('newPassword').dirty || submitted) && 
        !(passwordResetForm.get('newPassword').errors?.['required']) && (passwordResetForm.get('newPassword').invalid || passwordResetForm.hasError('passwordContainsEmail'))"
          role="alert" aria-live="assertive" id="newPasswordError" class="ontario-alert ontario-alert--error">

          <ul>
            <div *ngIf="
                passwordResetForm.get('newPassword').invalid &&
                passwordResetForm.get('newPassword').hasError('startC')
              ">
              <li>
                {{
                "bss.passwordReset.error.password.beginCharacter" | translate
                }}
              </li>
            </div>

            <div *ngIf="
                passwordResetForm.get('newPassword').invalid &&
                passwordResetForm.get('newPassword').hasError('strongL')
              ">
              <li>
                {{
                "bss.passwordReset.error.password.needLowerCase" | translate
                }}
              </li>
            </div>

            <div *ngIf="
                passwordResetForm.get('newPassword').invalid &&
                passwordResetForm.get('newPassword').hasError('strongU')
              ">
              <li>
                {{
                "bss.passwordReset.error.password.needUpperCase" | translate
                }}
              </li>
            </div>

            <div *ngIf="
                passwordResetForm.get('newPassword').invalid &&
                passwordResetForm.get('newPassword').hasError('strongD')
              ">
              <li>
                {{ "bss.passwordReset.error.password.needDigit" | translate }}
              </li>
            </div>

            <div *ngIf="
                passwordResetForm.get('newPassword').invalid &&
                passwordResetForm.get('newPassword').hasError('strongS')
              ">
              <li>
                {{
                "bss.passwordReset.error.password.needSpecialChar" | translate
                }}
              </li>
            </div>

            <div *ngIf="
                passwordResetForm.get('newPassword').invalid &&
                passwordResetForm.get('newPassword').hasError('strongDS')">
              <li>
                {{
                "bss.register.error.password.disAllowedSpecialChar" | translate
                }}
              </li>
            </div>

            <div *ngIf="
                passwordResetForm.get('newPassword').invalid &&
                passwordResetForm.get('newPassword').hasError('strongR')
              ">
              <li>
                {{
                "bss.passwordReset.error.password.repeatedChar" | translate
                }}
              </li>
            </div>

            <div *ngIf="passwordResetForm.get('newPassword').invalid && 
                (passwordResetForm.get('newPassword').errors?.['minlength'] 
                || passwordResetForm.get('newPassword').errors?.['maxlength'] 
                || passwordResetForm.get('newPassword').hasError('passwordTooShort'))">
              <li>
                {{ "bss.passwordReset.error.password.length" | translate }}
              </li>
            </div>

             <div *ngIf="passwordResetForm.hasError('passwordContainsEmail')">
              <li>
                {{
                "bss.passwordReset.error.password.containEmail" | translate
                }}
              </li>
            </div>

          </ul>
        </div>

      </div>
    </dd></dl>
  </div>

  <div class="ontario-row">
    <dl><dt></dt><dd>
      <div class="ontario-columns ontario-small-12 ontario-medium-3">
        <label class="ontario-label" for="confirmNewPassword">
          {{ "bss.passwordReset.confirmNewPassword" | translate }}
          <span class="ontario-label__flag">
            ({{ "bss.passwordReset.required" | translate }})
          </span>
        </label>
      </div>
      <div class="ontario-columns ontario-small-12 ontario-medium-9">
        <div class="toggle-container ontario-input--20-char-width">
          <input tabindex="107" class="ontario-input ontario-input--20-char-width"
            type="{{ showPasswordConfirm === false ? 'password' : 'text' }}" id="confirmNewPassword" title="{{
              'bss.passwordReset.confirmNewPassword.title' | translate
            }}" formControlName="confirmNewPassword" aria-describedby="confirmNewPasswordError" />
          <a tabindex="108" *ngIf="passwordResetForm.get('confirmNewPassword').value" id="passwordConfirmToggler"
            (click)="togglePasswordConfirm()"
            title="{{ showPasswordConfirm === false ? ('bss.passwordReset.showConfirmNewPassword.title' | translate) : ('bss.passwordReset.hideConfirmNewPassword.title' | translate) }}">
            {{ showPasswordConfirm === false ? ('bss.passwordReset.confirmNewPassword.show' | translate) :
            ('bss.passwordReset.confirmNewPassword.hide' | translate) }}
          </a>
        </div>

        <div *ngIf="submitted &&
           (passwordResetForm.get('confirmNewPassword').errors?.['required'])" role="alert" aria-live="assertive"
          id="confirmNewPasswordError" class="ontario-alert ontario-alert--error">
          <ul>
            <li>
              {{
              "bss.passwordReset.error.confirmNewPassword.required"
              | translate
              }}
            </li>
          </ul>
        </div>

        <div *ngIf="
            (passwordResetForm.get('confirmNewPassword').touched ||
              passwordResetForm.get('confirmNewPassword').dirty) &&
            passwordResetForm.hasError('mismatch')
          " role="alert" aria-live="assertive" id="confirmNewPasswordError" class="ontario-alert ontario-alert--error">
          <ul>
            <li>
              {{
              "bss.passwordReset.error.confirmNewPassword.mismatch"
              | translate
              }}
            </li>
          </ul>
        </div>
      </div>
    </dd></dl>
  </div>

  <div class="ontario-row">
    <dl><dt></dt><dd>
      <div class="ontario-column ontario-small-12">
        <button tabindex="109" aria-describedby="pageLevelMessageId" class="ontario-button"
          [ngClass]="{'ontario-button--primary': !isSubmitting}"
          title="{{ 'bss.passwordReset.submit.title' | translate }}" type="submit" [disabled]="isSubmitting">
          <!-- (click)="onSubmit()" (keyup.enter)="onSubmit()" -->
          {{ "bss.passwordReset.submit" | translate }}
        </button>
        <button tabindex="110" type="button" class="ontario-button ontario-button--secondary"
          title="{{ 'bss.passwordReset.cancel.title' | translate }}" (click)="onCancel()">
          {{ "bss.passwordReset.cancel" | translate }}
        </button>

      </div>
    </dd></dl>
  </div>
</form>
<dialog class="ontario-progress" #progressDialog>
  <app-progress></app-progress>
</dialog>